import { IODataResponse } from "../interfaces/general";
import { sendMetadataGetRequestAsync } from "./definitions/MetadataApi";
import { cachedWrapper, IPromiseCache } from "./utilities/MemoryCachingHelpers";

export class EnvironmentVariables {
    private static _environmentVariables: IPromiseCache<IEnvironmentVariable[]> = {};

    static async retrieve(name: string): Promise<IEnvironmentVariable | undefined> {
        const variables = await this._load();
        const variable = variables.find(v => v.schemaName.toLowerCase() === name.toLowerCase());
        return variable;
    }

    private static async _load(force: boolean = false): Promise<IEnvironmentVariable[]> {
        if (force) {
            this._environmentVariables = {};
        }
        return cachedWrapper("ENVIRONMENT_VARIABLES", async () => {
            const result = await sendMetadataGetRequestAsync(`v1.0/talxis_RetrieveEnvironmentVariables`);
            if (!result.ok) {
                throw new Error(`Failed to retrieve environment variables: ${result.statusText}`);
            }
            const environmentVariables: IODataResponse<IEnvironmentVariable> = await result.json();

            return environmentVariables.value;
        }, this._environmentVariables);
    }
}

export interface IEnvironmentVariable {
    schemaName: string;
    value: string;
    type: number;
    isDefault: boolean;
}